import styled from "styled-components";
export default function Divider() {
  return (
    <Wrapper>
      <div id="divider"></div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
    #divider::before {
      content: "";
      position: relative;
      display: block;
      width: 120px;
      height: 1px;
      background: rgb(212, 208, 208);
      bottom: 0px;
      left: calc(50% - 60px);
      margin-top: 2px;
      margin-bottom: 0px;
    }
    #divider::after {
      content: "";
      position: relative;
      display: block;
      width: 40px;
      height: 3px;
      background: var(--accentcolor0);
      left: calc(50% - 20px);
      margin-top: 2px;
      margin-bottom: 15px;
      justify-content: center;
      padding: 0;
      bottom: 4px;
    }
`;
